__turbopack_context__.v({
  "footnote": "BlockSubNavCardGroup-module-scss-module__EaODya__footnote",
  "inner": "BlockSubNavCardGroup-module-scss-module__EaODya__inner",
  "root": "BlockSubNavCardGroup-module-scss-module__EaODya__root",
  "sections": "BlockSubNavCardGroup-module-scss-module__EaODya__sections",
  "subnav": "BlockSubNavCardGroup-module-scss-module__EaODya__subnav",
});
